<template>
    <div>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <h3 style='display: inline-block'>账号</h3>
                <el-alert
                    v-for='(item, index) in warningMsgList' :key='index'
                    style='margin-top: 1rem'
                    :title="item"
                    :closable='false'
                    type="warning">
                </el-alert>
            </div>
            <el-form label-position='left' inline :model='userInfo' :rules='rules' ref='updateAccountInfo'>
                <div v-if='updateUserInfoStatus.updateAccount'>
                    <el-form-item label="账号" prop="account" key='updateAccount'>
                        <el-input size='medium' v-model='userInfo.account' placeholder='请输入用户名'/>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitUpdateUserInfo">更改</el-button>
                        <el-button @click="updateUserInfoStatus.updateAccount = false">取消</el-button>
                    </el-form-item>
                </div>
                <div v-if='!updateUserInfoStatus.updateAccount'>
                    <el-form-item label="账号">
                        <span>{{userInfo.account}}</span>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon='el-icon-edit' type='text' @click="updateUserInfoStatus.updateAccount = true">更改</el-button>
                    </el-form-item>
                </div>
                <el-form-item label="退出登录">
                    <el-button type="danger" size='mini' @click='exitAccount'>退出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        
        <el-card style='margin-top: 2rem;' class="box-card">
            <div slot="header" class="clearfix">
                <h3>手机号</h3>
            </div>
            <!-- 换绑手机号 -->
            <div v-if='updateUserInfoStatus.updatePhone && userInfo.phone'>
                <div v-if='!captchaInfo.verifyStatus'>
                    <el-form label-position='left' ref='changeMyPhone' :rules='rules' :model='captchaInfo' label-width='80px'>
                        <el-form-item label='验证码' prop='captcha'>
                            <el-input type='number' v-model='captchaInfo.captcha' style='width: 50%' placeholder='请输验证码'/>
                            &nbsp;&nbsp;<el-button type="text" :disabled='captchaInfo.sendCaptchaStatus' @click='sendCaptchaByAccount'>
                            {{captchaInfo.sendCaptchaStatus ? `${captchaInfo.resendTime}秒后重新发送` : '发送验证码'}}</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type='primary' size='mini' @click='verifyCaptcha'>验证</el-button>
                            <el-button type="info" size='mini' @click='closePhoneUpdate'>关闭</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-if='captchaInfo.verifyStatus'>
                    <el-form label-position='left' ref='changeMyPhone' :rules='rules' :model='captchaInfo' label-width='80px'>
                        <el-form-item label='新手机号' key='phone' prop='phone'>
                            <el-input type='number' v-model='captchaInfo.phone' placeholder='请输入新手机号'/>
                        </el-form-item>
                        <el-form-item label='验证码' key='captcha'>
                            <el-input type='number' v-model='captchaInfo.captcha' style='width: 50%' placeholder='请输入验证码'/>
                            &nbsp;&nbsp;<el-button type="text" :disabled='captchaInfo.sendCaptchaStatus' @click='sendCaptchaByPhone("changeMyPhone")'>
                            {{captchaInfo.sendCaptchaStatus ? `${captchaInfo.resendTime}秒后重新发送` : '发送验证码'}}</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button :disabled='!captchaInfo.sendCaptchaStatus' type="primary" size='mini' @click='updateOrAddPhone("changeMyPhone")'>确定</el-button>
                            <el-button type="info" size='mini' @click='closePhoneUpdate'>关闭</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            
            <!-- 添加手机号 -->
            <div v-if='updateUserInfoStatus.updatePhone && !userInfo.phone'>
                <el-form label-position='left' ref='addNewPhone' :rules='rules' :model='captchaInfo' label-width='80px'>
                    <el-form-item label='手机号' key='phone' prop='phone'>
                        <el-input type='number' v-model='captchaInfo.phone' placeholder='请输入手机号'/>
                    </el-form-item>
                    <el-form-item label='验证码' key='captcha'>
                        <el-input type='number' v-model='captchaInfo.captcha' style='width: 50%' placeholder='请输入验证码'/>
                        &nbsp;&nbsp;<el-button type="text" :disabled='captchaInfo.sendCaptchaStatus' @click='sendCaptchaByPhone("addNewPhone")'>
                        {{captchaInfo.sendCaptchaStatus ? `${captchaInfo.resendTime}秒后重新发送` : '发送验证码'}}</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size='mini' @click='updateOrAddPhone("addNewPhone")'>确定</el-button>
                        <el-button type="info" size='mini' @click='closePhoneUpdate'>关闭</el-button>
                    </el-form-item>
                </el-form>
            </div>
            
            <!--展示手机号-->
            <el-form v-if='!updateUserInfoStatus.updatePhone' label-position='left' inline>
                <el-form-item label="手机号" prop="age">
                    <p>{{userInfo.phone}}</p>
                </el-form-item>
                <el-form-item>
                    <el-button @click="updateUserInfoStatus.updatePhone = true" type='text'>{{userInfo.phone ? '换绑' : '绑定'}}</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        
        <el-card v-if='false' style='margin-top: 2rem;' class="box-card">
            <div slot="header" class="clearfix">
                <h3>邮箱</h3>
            </div>
            <el-form label-position='left' inline>
                <div v-if='updateUserInfoStatus.updateEmail'>
                    <el-form-item label="邮箱" prop="age">
                        <el-input size='medium' v-model='userInfo.email' placeholder='请输入邮箱'/>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="bindEmail">发送验证</el-button>
                        <el-button @click="updateUserInfoStatus.updateEmail = false">取消</el-button>
                    </el-form-item>
                </div>
                <div v-if='!updateUserInfoStatus.updateEmail'>
                    <el-form-item label="邮箱" prop="age">
                        <span>{{userInfo.email}}</span>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon='el-icon-edit' type='text' @click="updateUserInfoStatus.updateEmail = true">更改</el-button>
                        &nbsp;&nbsp;<el-button type='text' v-if='userInfo.email' @click="unbindEmail">解绑</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </el-card>
        
        <!-- 如果存在手机号，则通过手机号验证 -->
        <el-card style='margin-top: 2rem;' class="box-card">
            <div slot="header" class="clearfix">
                <h3>修改密码</h3>
            </div>
            <div v-if='!userInfo.passwordStatus'>
                <el-form :model="userPassword" status-icon :rules="rules" ref="updatePwdNoPhone" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="密码" prop="password" key='password'>
                        <el-input show-password type="password" v-model="userPassword.password" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="newPassword" key='newPassword'>
                        <el-input show-password type="password" v-model="userPassword.newPassword" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="updatePassword('updatePwdNoPhone')">修改</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div v-else>
                <div v-if='userInfo.phone'>
                    <el-form label-position='left' ref='updatePwdByPhone' :rules='rules' :model='userPassword' label-width='80px'>
                        <el-form-item label='验证码' key='captcha' prop='captcha'>
                            <el-input type='number' v-model='userPassword.captcha' style='width: 50%' placeholder='请输验证码'/>
                            &nbsp;&nbsp;<el-button type="text" :disabled='userPassword.sendCaptchaStatus' @click='updatePwdSendCaptchaByAccount'>
                            {{userPassword.sendCaptchaStatus ? `${userPassword.resendTime}秒后重新发送` : '发送验证码'}}</el-button>
                        </el-form-item>
                        
                        <el-form-item label="密码" prop="password" key='password'>
                            <el-input show-password type="password" v-model="userPassword.password" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="newPassword" key='newPassword'>
                            <el-input show-password type="password" v-model="userPassword.newPassword" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="updatePwdByPhone('updatePwdByPhone')">修改</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-else>
                    <el-form :model="userPassword" status-icon :rules="rules" ref="updatePwdPhone" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="原密码" prop="originPassword" key='originPassword'>
                            <el-input show-password type="password" v-model="userPassword.originPassword" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="password" key='password'>
                            <el-input show-password type="password" v-model="userPassword.password" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="newPassword" key='newPassword'>
                            <el-input show-password type="password" v-model="userPassword.newPassword" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="updatePassword('updatePwdPhone')">修改</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-card>
        
        <el-card style='margin-top: 2rem;' class="box-card">
            <div slot="header" class="clearfix">
                <h3>其他</h3>
            </div>
            <div>
                <el-form class="demo-ruleForm">
                    <el-form-item label="注册时间" prop="password">
                        <p>{{userInfo.createTime}}</p>
                    </el-form-item>
                    <el-form-item label="登录平台" prop="password">
                        <el-tag v-for='(item, index) in computedPlatformArr' style='margin-right: 1rem;' :key='index'>{{item}}</el-tag>
                    </el-form-item>
                    <el-form-item label="账号注销">
                        <el-button type="danger" size='mini' @click='deleteAccount'>注销</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { accountApi } from '@/service/api/accountApi';
import { message } from '@/utils/message';
import { localStg } from '@/utils/storage/local';

export default defineComponent({
    name: 'index',
    data() {
        let validatePass = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        };
        let originValidatePass = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入原密码'));
            } else {
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.userPassword.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            userInfo: {},
            updateUserInfoStatus: {
                updateAccount: false,
                updateEmail: false,
                updatePhone: false
            },
            captchaInfo: {
                captcha: '',
                verifyStatus: false,
                resendTime: 60,
                phone: undefined,
                sendCaptchaStatus: false
            },
            warningMsgList: [],
            time: undefined,
            updatePwdTime: undefined,
            rules: {
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                newPassword: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
                originPassword: [
                    { validator: originValidatePass, trigger: 'blur' }
                ],
                phone: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入手机号'));
                            }else {
                                callback()
                            }
                        }
                    }
                ],
                captcha: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入验证码'));
                            }else {
                                callback()
                            }
                        }
                    }
                ],
                account: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入账号'));
                            }else {
                                callback()
                            }
                        }
                    }
                ],
            },
            userPassword: {
                password: undefined,
                newPassword: undefined,
                originPassword: undefined,
                verifyCaptchaStatus: false,
                sendCaptchaStatus: false,
                resendTime: 60,
                captcha: undefined
            }
        }
    },
    created() {
        this.getUserInfo()
    },
    computed: {
        computedPlatformArr() {
            if (!this.userInfo.platform) {
                return []
            }
            return this.userInfo.platform.split(",")
        }
    },
    methods: {
        getUserInfo() {
            accountApi.queryUserDetailInfo().then(result => {
                if (result.code === 200) {
                    this.userInfo = result.data
                    if (!this.userInfo.passwordStatus) {
                        this.warningMsgList.push("您的账号未设置密码，为了登录方便以及保证您的账号安全，请设置密码")
                    }
                    if (!this.userInfo.phone) {
                        this.warningMsgList.push("您的账号未绑定手机号，为了登录方便以及保证您的账号安全，请绑定手机号")
                    }
                }
            })
        },
        submitUpdateUserInfo() {
            this.$refs.updateAccountInfo.validate((valid) => {
                if (!valid) {
                    return false
                }
                accountApi.updateUserInfo(this.userInfo).then(result => {
                    if (result.code === 200) {
                        message.success("更改成功")
                    }
                })
            });
        },
        formValidate(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return false
                }
            });
        },
        sendCaptchaByAccount() {
            accountApi.sendCaptchaByAccount({account: this.userInfo.account}).then(result => {
                if (result.code === 200) {
                    message.success("验证码已发送，请检查该账号绑定的手机号")
                    this.captchaInfo.sendCaptchaStatus = true
                    this.time = setInterval(() => {
                        if (this.captchaInfo.resendTime <= 1) {
                            clearInterval(this.time)
                            this.captchaInfo.resendTime = 60
                            this.captchaInfo.sendCaptchaStatus = false
                        }
                        this.captchaInfo.resendTime = this.captchaInfo.resendTime - 1
                    }, 1000)
                }
            })
        },
        updatePwdSendCaptchaByAccount() {
            accountApi.sendCaptchaByAccount({account: this.userInfo.account}).then(result => {
                if (result.code === 200) {
                    message.success("验证码已发送，请检查该账号绑定的手机号")
                    this.userPassword.sendCaptchaStatus = true
                    this.updatePwdTime = setInterval(() => {
                        if (this.userPassword.resendTime <= 1) {
                            clearInterval(this.updatePwdTime)
                            this.userPassword.resendTime = 60
                            this.userPassword.sendCaptchaStatus = false
                        }
                        this.userPassword.resendTime = this.userPassword.resendTime - 1
                    }, 1000)
                }
            })
        },
        verifyCaptcha() {
            if (!this.captchaInfo.captcha) {
                message.error("请输入验证码")
                return
            }
            accountApi.checkPhoneCaptcha({phone: this.userInfo.phone, captcha: this.captchaInfo.captcha}).then(result => {
                if (result.code === 200) {
                    clearInterval(this.time)
                    this.captchaInfo.captcha = undefined
                    this.captchaInfo.phone = undefined
                    this.captchaInfo.verifyStatus = true
                    
                    this.captchaInfo.sendCaptchaStatus = false
                    this.captchaInfo.resendTime = 60
                }else {
                    message.error(result.message)
                }
            })
        },
        
        updateOrAddPhone(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) {
                    return false
                }
                accountApi.updateOrAddPhone({userId: this.userInfo.userId, phone: this.captchaInfo.phone, captcha: this.captchaInfo.captcha}).then(result => {
                    if (result.code === 200) {
                        clearInterval(this.time)
                        this.captchaInfo.resendTime = 60
                        this.updateUserInfoStatus.updatePhone = false
                        this.captchaInfo.sendCaptchaStatus = false
                        if (this.userInfo.phone) {
                            message.success("换绑成功")
                        }else {
                            message.success("绑定成功")
                        }
                        this.getUserInfo()
                    }
                })
            })
        },
        sendCaptchaByPhone(formName) {
            if (this.captchaInfo.sendCaptchaStatus) {
                return;
            }
            this.$refs[formName].validate(valid => {
                if (!valid) {
                    return false
                }
                accountApi.sendCaptchaByPhone({phone: this.captchaInfo.phone}).then(result => {
                    if (result.code === 200) {
                        this.captchaInfo.sendCaptchaStatus = true
                        this.time = setInterval(() => {
                            if (this.captchaInfo.resendTime <= 1) {
                                clearInterval(this.time)
                                this.captchaInfo.resendTime = 60
                                this.captchaInfo.sendCaptchaStatus = false
                            }
                            this.captchaInfo.resendTime = this.captchaInfo.resendTime - 1
                        }, 1000)
                        message.success("验证码已发送，请检查该手机")
                    }else {
                        message.error(result.message)
                    }
                })
            })
        },
        
        closePhoneUpdate() {
            clearInterval(this.time)
            this.updateUserInfoStatus.updatePhone = false
            this.captchaInfo = {
                captcha: '',
                verifyStatus: false,
                resendTime: 60,
                phone: undefined,
                sendCaptchaStatus: false
            }
        },
        
        bindEmail() {
            if (!this.userInfo.email) {
                message.error("请输入邮箱")
                return
            }
        },
        
        unbindEmail() {
            message.error("解除绑定")
        },
        updatePassword(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    accountApi.updatePassword({password: this.userPassword.originPassword, newPassword: this.userPassword.newPassword}).then(result => {
                        if (result.code === 200) {
                            message.success("修改成功")
                            this.getUserInfo()
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        
        updatePwdByPhone(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) {
                    return false;
                }
                accountApi.updatePasswordByPhone({phone: this.userInfo.phone, captcha: this.userPassword.captcha,
                    password: this.userPassword.password}).then(result => {
                    if (result.code === 200) {
                        message.success("修改成功")
                        this.getUserInfo()
                    }
                })
            })
        },
        exitAccount() {
            localStg.clear()
            this.$router.push('/login')
        },
        deleteAccount() {
            let obj = this
            this.$modal.confirm(`是否确定要注销${this.userInfo.account} 账户？账户注销之后，会有15天的缓冲期，15天内，再次登录，会重新激活该账户。如果15天后，该账户未被重新激活，则账户会被自动删除！`).then(function() {
                return accountApi.deletePlayer()
            }).then((result) => {
                if (result.code === 200) {
                    message.success("注销成功")
                    obj.exitAccount()
                }
            }).catch(() => {
            });
        }
    }
});
</script>

<style scoped lang='css'>
.account-input {
    width: 40%;
}
</style>
